<div class="favorite-shoe-card">
    <h3 tabindex="0">{{shoe.name}}</h3>
    <img src="{{shoe.img}}" class="img-responsive" alt="picture of the {{shoe.name}}" width = "100%" tabindex="0">
    <ul tabindex="0">
        <li>Model: {{shoe.shoe}}</li>
        <li>Price: ${{shoe.retailPrice}}</li>
    </ul>
    <button (click)="removeFromFavorites();" id="remove-button" class="fa fa-minus">Remove from Favorites</button>
</div>